import { useState, useEffect } from "react";
import { useAppDispatch } from "app/hooks";
import { useAppSelector } from "app/hooks";
import { getMenu } from "app/features/menuSlice";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Drawer from "../Drawer/Drawer";
import { Link, Outlet } from "react-router-dom";
import MenuItem from "./components/MenuItem";
import MenuLog from "./components/MenuLog";
import NewToast from "ui/atoms/NewToast";

const NavBar = () => {
  const { accounts } = useMsal();
  const dispatch = useAppDispatch();
  const isAuthenticated = useIsAuthenticated();
  const [open, setOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuId, setMenuId] = useState("");

  const response = useAppSelector((state) => state.currentMenu);
  const { menu, error } = response;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setMenuId(event.currentTarget.id);
  };

  const handleClose = () => {
    setMenuId("");
  };

  useEffect(() => {
    if (isAuthenticated) {
      const userLogged = accounts[0]?.username;
      dispatch(getMenu(userLogged));
    }
    if (error?.description) setOpenToast(true);
  }, [isAuthenticated, error?.description]);

  const onCloseToast = () => setOpenToast(!openToast);

  return (
    <>
      <NewToast open={openToast} setOpen={onCloseToast} severity='warning'>
        {error?.description}
      </NewToast>
      <Box sx={{ display: "flex" }}>
        <AppBar component='nav'>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <IconButton
              color='inherit'
              aria-label='open drawer'
              edge='start'
              onClick={() => setOpen(!open)}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant='h6' component='div' sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}>
              Portal GR
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Link to='/'>
                <Button sx={{ color: "#fff" }}>Inicio</Button>
              </Link>
              <MenuItem
                menuId={menuId}
                anchorEl={anchorEl}
                handleClose={handleClose}
                handleClick={handleClick}
                menuItems={menu || []}
              />
            </Box>
            <MenuLog />
          </Toolbar>
        </AppBar>
        <Box component='nav'>
          <Drawer open={open} setOpen={setOpen} menuArray={menu} />
        </Box>
        <Box component='main' sx={{ p: 1 }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default NavBar;
